export default __webpack_public_path__ + "static/media/icon-sidebar-small.7a84a6b2.png";